import React from 'react';
import { ErrorMessage, Grid, SpaceWrapper } from 'ui-toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { LenderContactsBlock } from '../../components/lenders/LenderContactsBlock';
import { LenderDetailsHeader } from '../../components/lenders/LenderDetailsHeader';
import { LenderDetails } from '../../components/lenders/LenderDetails';
import { ILenderInformationData } from '../../types/lenders/ILenderInformation';
import { ILenderContactData } from '../../types/contacts/ILenderContact';

interface ILenderCompanyPageProps {
  lenderId: string;
  companyName: string;
  pageError?: Error;
  lenderInfo: ILenderInformationData;
  lenderContacts: ILenderContactData[];
  onAddContact: (data: ILenderContactData) => void;
  onAddContactReset: () => void;
  addContactFetchStatus: IFetchStatus;
  getContactFetchStatus: IFetchStatus;
  addContactError?: Error;
  actionContactError?: Error;
  onEditContact: (data: ILenderContactData) => void;
  onEditContactReset: () => void;
  editContactFetchStatus: IFetchStatus;
  editContactError?: Error;
}

export const LenderCompanyPage: React.FC<ILenderCompanyPageProps> = ({
  lenderId,
  companyName,
  pageError,
  lenderInfo,
  lenderContacts,
  onAddContact,
  onAddContactReset,
  addContactFetchStatus,
  getContactFetchStatus,
  addContactError,
  onEditContact,
  onEditContactReset,
  editContactFetchStatus,
  editContactError,
}) => {
  return (
    <SpaceWrapper>
      <Grid>
        <ErrorMessage error={pageError} />
        <LenderDetailsHeader lenderId={lenderId} companyName={companyName} />
        <LenderDetails lender={lenderInfo} />
        <LenderContactsBlock
          editContactError={editContactError}
          editContactFetchStatus={editContactFetchStatus}
          onEditContactReset={onEditContactReset}
          onEditContact={onEditContact}
          onAddContactReset={onAddContactReset}
          onAddContact={onAddContact}
          addContactError={addContactError}
          addContactFetchStatus={addContactFetchStatus}
          getContactFetchStatus={getContactFetchStatus}
          lenderContacts={lenderContacts}
        />
      </Grid>
    </SpaceWrapper>
  );
};
